function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#292F33",
  d: "M7 11h22v18H7z"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#CCD6DD",
  d: "M8 29c0 1.104-.597 2-1.333 2H5.333C4.597 31 4 30.104 4 29V11c0-1.104.597-2 1.333-2h1.333C7.403 9 8 9.896 8 11v18zm24 0c0 1.104-.597 2-1.333 2h-1.334C28.597 31 28 30.104 28 29V11c0-1.104.597-2 1.333-2h1.334C31.403 9 32 9.896 32 11v18zm-16 0c0 1.104-.597 2-1.333 2h-1.333C12.597 31 12 30.104 12 29V11c0-1.104.597-2 1.333-2h1.333C15.403 9 16 9.896 16 11v18zm8 0c0 1.104-.598 2-1.334 2h-1.332C20.598 31 20 30.104 20 29V11c0-1.104.598-2 1.334-2h1.332C23.402 9 24 9.896 24 11v18z"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#9AAAB4",
  d: "M33 30c0 1.104-.896 2-2 2H5c-1.104 0-2-.896-2-2s.896-2 2-2h26c1.104 0 2 .896 2 2z"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#CCD6DD",
  d: "M35 32c0 1.104-.896 2-2 2H3c-1.104 0-2-.896-2-2s.896-2 2-2h30c1.104 0 2 .896 2 2z"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#E1E8ED",
  d: "M36 33.5c0 .828-.672 1.5-1.5 1.5h-33C.671 35 0 34.328 0 33.5S.671 32 1.5 32h33c.828 0 1.5.672 1.5 1.5z"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#9AAAB4",
  d: "M33 10c0-1.104-.956-2-2.133-2H5c-1.179 0-2 .896-2 2 0 .751.386 1.398 1 1.74V13h4v-1h4v1h4v-1h4v1h4v-1h4v1h4v-1.312c.599-.354 1-.975 1-1.688z"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#CCD6DD",
  d: "M2 8.444C2 7.413 3.012 7 3.012 7l14.904-7 15.047 7S34 7.231 34 8.45V9H2v-.556z"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#9AAAB4",
  d: "M18 2.542S7.681 7.407 6.65 7.844C5.619 8.281 5.964 9 6.651 9h22.646c1.062 0 .812-.812-.031-1.25C28.422 7.312 18 2.542 18 2.542z"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  fill: "#CCD6DD",
  d: "M34 9c0 .552-.447 1-1 1H3c-.552 0-1-.448-1-1s.448-1 1-1l30 .006c.553 0 1 .442 1 .994z"
});
var SvgInstitutionIcon = function SvgInstitutionIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstitutionIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/institution-icon.dbe34f53.svg";
export { ForwardRef as ReactComponent };